import { Box, Chip, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IDevice } from "interfaces/device.interface";

export const GridStyled = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  textDecoration: "none",
  alignItems: "center",
  boxShadow: "0px 0px 1px 1px rgba(0, 0, 0, 0.1)",
  borderRadius: "4px",
  width: "100%",
  padding: "8px 16px",
  margin: 0,
  marginBottom: 16,
  cursor: "pointer",
  "&:hover": {
    background: theme.vars.palette.background.paper,
    boxShadow: "0px 0px 1px 1px rgba(0, 0, 0, 0.1)",
  },
})) as typeof Box;

type DeviceRowProps = {
  device: Pick<IDevice, "id" | "name" | "serial_number" | "online">;
};

export function DeviceRow({ device }: DeviceRowProps) {
  const { t } = useTranslation();
  const status = device.online ? "online" : "offline";

  return (
    <GridStyled component={Link} to={`../devices/${device.id}`}>
      <Box>
        <Typography variant={"bodyLargeMedium"} color={"textPrimary"}>
          {device.name}
        </Typography>
        <Typography variant={"bodyDefaultRegular"} color={"textPrimary"}>
          {device.serial_number}
        </Typography>
      </Box>
      <Box>
        <Chip
          label={t(status)}
          color={status === "online" ? "primary" : "error"}
        />
      </Box>
    </GridStyled>
  );
}
